import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const rowIsIndividualPart =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem?.type === 'Row') {
      const assembly = bomItemSelector(state, bomItem.parentId)
      if (assembly.type === 'Assembly') {
        return !assembly.hasGeometry
      }
      return assembly
    }

    return false
  }
